import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { motion, AnimatePresence } from "framer-motion";
import { FaLinkedin, FaTwitter, FaGithub, FaInstagram } from 'react-icons/fa'; 
import Tilt from 'react-parallax-tilt';

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  exit: { opacity: 0, y: -20, transition: { duration: 0.3 } }
};

const Contact = () => {
  const form = useRef();
  const [popupMessage, setPopupMessage] = useState('');
  const [showPopup, setShowPopup] = useState(false);

  // New states for form fields
  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [message, setMessage] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm('service_9j3a177', 'template_0uzknzn', form.current, 'roDAQSRS_JjqQtVXE')
      .then((result) => {
        setPopupMessage('Message sent successfully!');
        setShowPopup(true);
        
        // Clear input fields after successful send
        setUserName('');
        setUserEmail('');
        setMessage('');
      }, (error) => {
        setPopupMessage('Failed to send message. Please try again.');
        setShowPopup(true);
      });
      
    setTimeout(() => setShowPopup(false), 3000);
  };

  return (
    <div id="contact" className="relative w-full h-screen flex justify-center items-center bg-black text-white overflow-hidden">
      <div className="absolute inset-0 grid grid-cols-8 opacity-5 pointer-events-none">
        {[...Array(64)].map((_, i) => (
          <div key={i} className="border-[0.5px] border-white/20" />
        ))}
      </div>

      <motion.div
        initial="hidden"
        animate="show"
        variants={fadeIn}
        viewport={{ once: false }}
        className="relative z-10 w-full m-5 max-w-3xl bg-zinc-900 bg-opacity-90 p-8 rounded-lg shadow-lg"
      >
        <motion.h1
          className="text-4xl sm:text-2xl md:text-3xl font-semibold text-center flex flex-col justify-center items-center mb-6 font-[rekind] text-cyan-400"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 300 }}
          viewport={{ once: false }}
        >
          Let's Connect
          <div className="h-1 w-20 bg-cyan-400 rounded-full mb-12 pr-5" />
        </motion.h1>

        <div className="flex justify-center space-x-6 mb-8 ">
          {[
            { Icon: FaLinkedin, link: "https://www.linkedin.com/in/yahya24" },
            { Icon: FaTwitter, link: "https://twitter.com/tunkstun2" },
            { Icon: FaGithub, link: "https://github.com/tunkstun" },
            { Icon: FaInstagram, link: "https://instagram.com/solo_perfecto24" },
          ].map(({ Icon, link }, index) => (
            <Tilt key={index} className="tilt">
              <motion.a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Social Link"
                whileHover={{ scale: 1.02 }}
                className="text-3xl sm:text-xl md:text-2xl text-white hover:text-cyan-400 transition"
              >
                <Icon />
              </motion.a>
            </Tilt>
          ))}
        </div>

        <motion.form
          ref={form}
          onSubmit={sendEmail}
          className="space-y-6 items-center justify-center flex flex-col"
          initial="hidden"
          animate="show"
          exit="exit"
          variants={fadeIn}
        >
          <input 
            type="text" 
            name="user_name" 
            value={userName} // Bind state to input
            onChange={(e) => setUserName(e.target.value)} // Update state on change
            className="p-3 w-full border border-white/10 rounded-md bg-black/80 text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition" 
            placeholder="Name" 
            required 
          />
          <input 
            type="email" 
            name="user_email" 
            value={userEmail} // Bind state to input
            onChange={(e) => setUserEmail(e.target.value)} // Update state on change
            className="p-3 w-full border border-white/10 rounded-md bg-black/80 text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition" 
            placeholder="Email" 
            required 
          />
          <textarea 
            name="message" 
            rows="4" 
            value={message} // Bind state to input
            onChange={(e) => setMessage(e.target.value)} // Update state on change
            className="p-3 w-full border border-white/10 rounded-md bg-black/80 text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition" 
            placeholder="Message" 
            required 
          />
          <motion.button
            type="submit"
            className="py-3 w-1/2 bg-cyan-200 text-black rounded-md hover:bg-white transition-colors"
            whileHover={{ y: -3 }}
            whileTap={{ scale: 0.98 }}
          >
            Send Message
          </motion.button>
        </motion.form>
      </motion.div>

      <AnimatePresence>
        {showPopup && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="absolute bottom-10 left-1/2 transform -translate-x-1/2 bg-black text-white py-2 px-4 rounded-lg shadow-lg"
          >
            {popupMessage}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Contact;
